import { getInstance } from "../utils/helpers";

function getCountries() {
  const url = `/api/countries/list`;
  return getInstance().get(url);
}

export { getCountries };
